import { ApiService } from './api-service';

export class FileService extends ApiService {
  getFile = uuid => this.get(`/service/file/${uuid}`, { mode: 'DOWNLOAD_MODE' }, { responseType: 'blob' });
}

export default new FileService();
